"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatExpiryDate = exports.formatCardPan = void 0;
var _dateFns = require("date-fns");
var formatCardPan = function formatCardPan(pan) {
  return pan.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();
};
exports.formatCardPan = formatCardPan;
var formatExpiryDate = function formatExpiryDate(expirationDate) {
  return (0, _dateFns.format)(expirationDate, 'MM/yy');
};
exports.formatExpiryDate = formatExpiryDate;